export const dev_configs = {
    serverUrl: process.env.REACT_APP_DEV_SERVER_URL,
    fileServer: process.env.REACT_APP_FILE_DEV_SERVER
}